import { mapGetters } from 'vuex'
import i18n from '@vue-storefront/i18n'
import { Logger } from '@vue-storefront/core/lib/logger'

export const OrderReview = {
  name: 'OrderReview',
  data () {
    return {
      isFilled: false,
      orderReview: {
        terms: false,
        contactToReplace: false
      }
    }
  },
  computed: {
    ...mapGetters({
      isVirtualCart: 'cart/isVirtualCart',
      cards: 'ipay-payment-user/getCards',
      defaultCard: 'ipay-payment-user/getDefaultCreditCard',
      ipayFee: 'ipay-payment-user/getFee',
      getTotalSubtotalPrice: 'cart/getTotalSubtotalPrice',
      getTotalDeliveryPrice: 'cart/getTotalDeliveryPrice',
      isCartLoading: 'cart/isCartLoading'
    }),
    deliveryPrice () {
      const deliveries = (this.shippingMethods || []).filter(shipping => shipping.method.method_code !== 'pickup')
      return deliveries.length ? this.getTotalDeliveryPrice(deliveries) : 0
    },
    isDeliveryPriceUnknown () {
      return this.deliveryPrice == null
    },
    paymentMethod () {
      return this.$store.state.checkout.paymentDetails.paymentMethod
    },
    transactionInfo () {
      return {
        totalPriceStatus: 'FINAL',
        totalPrice: parseFloat(this.deliveryPrice + this.getTotalSubtotalPrice + this.ipayFee).toString(),
        currencyCode: 'UAH',
        countryCode: 'UA'
      }
    },
    applePayTotals () {
      return {
        total: parseFloat(this.deliveryPrice + this.getTotalSubtotalPrice + this.ipayFee),
        subtotal: parseFloat(this.getTotalSubtotalPrice),
        shipping: parseFloat(this.deliveryPrice || 0),
        fee: parseFloat(this.ipayFee)
      }
    }
  },
  methods: {
    retryDeliveryPrice () {
      return this.$store.dispatch('cart/load', { refreshTotals: true, isUpdate: true })
    },
    callMeChanged (value) {
      this.$bus.$emit('checkout-contact-to-replace-changed', value)
    },
    placeOrder (event, comment) {
      if (this.$store.state.checkout.personalDetails.createAccount) {
        this.register()
      } else {
        this.$bus.$emit('checkout-do-placeOrder')
      }
    },
    async register () {
      this.$bus.$emit('notification-progress-start', i18n.t('Registering the account ...'))
      this.$store.dispatch('user/register', {
        email: this.$store.state.checkout.personalDetails.emailAddress,
        password: this.$store.state.checkout.personalDetails.password,
        firstname: this.$store.state.checkout.personalDetails.firstName,
        lastname: this.$store.state.checkout.personalDetails.lastName
      }).then(async (result) => {
        this.$bus.$emit('notification-progress-stop')
        if (result.code !== 200) {
          this.onFailure(result)
          // If error includes a word 'password', emit event that eventually focuses on a corresponding field
          if (result.result.includes(i18n.t('password'))) {
            this.$bus.$emit('checkout-after-validationError', 'password')
          }
          // If error includes a word 'mail', emit event that eventually focuses on a corresponding field
          if (result.result.includes(i18n.t('email'))) {
            this.$bus.$emit('checkout-after-validationError', 'email-address')
          }
        } else {
          this.$bus.$emit('modal-hide', 'modal-signup')
          await this.$store.dispatch('user/setCurrentUser', result.result) // set current user data to process it with the current order
          this.$bus.$emit('checkout-before-placeOrder', result.result.id)
          this.onSuccess()
        }
      }).catch(err => {
        this.$bus.$emit('notification-progress-stop')
        Logger.error(err, 'checkout')()
      })
    }
  }
}
